import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#28CA87",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#28CA87",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17.333 8.5 10 15.833 6.667 12.5"
    }, null, -1)
  ])))
}
export default { render: render }